import React, {forwardRef, HTMLAttributes, MutableRefObject, Ref, useRef} from 'react';
import classNames from 'classnames';

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react'
import { useState } from 'react'

import Action from './Tree/components/Action/Action.tsx';
import Handle from './Tree/components/Handle/Handle.tsx';
import Remove from './Tree/components//Remove/Remove.tsx';
import IsolateItem from './Tree/components//IsolateItem/IsolateItem.tsx';
import styles from './TreeItemCard.module.css';
import TaskTextField from './TaskTextField.js';

import { EmojiEvents } from '@mui/icons-material';


export interface Props extends Omit<HTMLAttributes<HTMLLIElement>, 'id'> {
  childCount?: number;
  clone?: boolean;
  collapsed?: boolean;
  estimatedCommencementDate?: string;
  idealCompletionDate?: string;
  latestPossibleCompletionDate?: string;
  done?: boolean;
  depth: number;
  disableInteraction?: boolean;
  disableSelection?: boolean;
  draggable?: boolean;
  ghost?: boolean;
  goal?: boolean;
  handleProps?: any;
  indicator?: boolean;
  indentationWidth: number;
  primaryLabel: string;
  selected?: boolean;
  status: string;
  value: string;  
  onCollapse?(): void;
  onDoneChanged?(): void;
  onGoalChanged?(): void;
  onEstimatedCommencementDateChanged?(newDate: string): void;
  onIdealDateChanged?(newDate: string): void;
  onPrimaryLabelChanged?(newPrimaryLabel: string): void;
  onLatestDateChanged?(newDate: string): void;
  onStatusChanged?(newStatus: string): void;
  onTitleChanged?(newTitle: string): void;
  onSelected?(): void;
  treeItemHandleOnfocus?(ctrlCreate: boolean ): void;
  handleOnSubmit?(): void;
  onRemove?(): void;
  onNavTo?(): void;
  wrapperRef?(node: HTMLLIElement): void;
  onSelectedStatusChanged?(): void;
  onSelectedPrimaryLabelChanged?(): void;
  selectedStatus: {id: number, name: string};
  selectedPrimaryLabel: {id: number, name: string};
  inputRef?: MutableRefObject<null> | null;
}

const states = [
  { id: 1, name: 'New' },
  { id: 2, name: 'Processing' },
  { id: 3, name: 'Ready' },
  { id: 4, name: 'Scheduled' },  
  { id: 5, name: 'In Progress' },  
  { id: 6, name: 'Completed' },
]

const primaryLabels = [
  { id: 1, name: 'None' },
  { id: 2, name: 'Career' },
  { id: 3, name: 'Finances' },
  { id: 4, name: 'Health' },
  { id: 5, name: 'Interests' },
  { id: 6, name: 'Knowledge' },  
  { id: 7, name: 'Lifestyle' },
  { id: 8, name: 'Organisation' },
  { id: 9, name: 'Social' }, 
  { id: 10, name: 'Relationships' },
]

export const TreeItemCard = forwardRef<HTMLDivElement, Props>(
  (
    {
      childCount,
      clone,
      collapsed,
      estimatedCommencementDate = '',
      idealCompletionDate = '',
      latestPossibleCompletionDate = '',
      done,
      depth,
      disableSelection,
      disableInteraction,
      draggable = true,
      ghost,
      goal,
      handleProps,
      indentationWidth,
      indicator,
      primaryLabel,
      // selected = false,
      status,      
      onCollapse,
      onDoneChanged,
      onGoalChanged,
      onEstimatedCommencementDateChanged,
      onIdealDateChanged,
      onLatestDateChanged,      
      onPrimaryLabelChanged,
      onStatusChanged,
      onTitleChanged,
      onSelected,
      treeItemHandleOnfocus,
      handleOnSubmit,
      onRemove,
      onNavTo,
      style,
      value,
      wrapperRef,
      onSelectedStatusChanged,
      onSelectedPrimaryLabelChanged,
      selectedStatus,
      selectedPrimaryLabel,
      inputRef,
      ...props
    },
    ref
  ) => {

    // const initialState = states.find(({name}) => name === status);
    
    // let initialPrimaryLabel;
    // let passedPrimaryLabel;
    // if(primaryLabel) {
    //   passedPrimaryLabel = primaryLabels.find(({name}) => name === primaryLabel);
    //   if(passedPrimaryLabel){
    //     initialPrimaryLabel = passedPrimaryLabel;
    //   }
    //   else {
    //     initialPrimaryLabel = {id:1, name:primaryLabel}; //TODO: Not sure what this is.
    //   }
    // }
    // else {
    //   initialPrimaryLabel = primaryLabels[0];
    // }

    // const [selectedState, setSelectedState] = useState(initialState ? initialState: states[0]);
    // const [selectedPrimaryLabel, setSelectedPrimaryLabel] = useState(initialPrimaryLabel ? initialPrimaryLabel: primaryLabels[0]);
    
    const [highlighted, setHighlighted] = useState(false);
    const [selected, setSelected] = useState(false);
    const [selectable, setSelectable] = useState(false);

    const [query, setQuery] = useState('');

    const localInputRefs = useRef([]); //TODO: Use a Map instead of an array.

    // if(onStatusChanged && initialState){
    //   onStatusChanged(initialState.name);
    // }

    function handleStatusChange(state) {
      setSelectedState(state);
      onStatusChanged(state.name);
    }

    function handlePrimaryLabelChange(primaryLabel) {
      setSelectedPrimaryLabel(primaryLabel);
      if(primaryLabel) {
        onPrimaryLabelChanged(primaryLabel.name);
      }
    }

    function handleClick() {
      //TODO: Set state to change appearance - a golden ring around the whole item for example.
      // selectable && 
      // onSelected && onSelected();
    }

    function handleMouseEntersListItemArea() {
      //TODO: Set state to change appearance - a golden ring around the whole item for example.
      selectable && setHighlighted(true);
    }

    function handleMouseLeavesListItemArea() {
      //TODO: Set state to change appearance - a golden ring around the whole item for example.
      setHighlighted(false);
    }

    function handleMouseEntersItemNonSelectionArea() {
      //TODO: Set state to change appearance - a golden ring around the whole item for example.
      setSelectable(false);
    }

    function handleMouseLeavesItemNonSelectionArea() {
      //TODO: Set state to change appearance - a golden ring around the whole item for example.
      // setSelectable(true);
    }

    function getSelectedPrimaryLabel() {
      if(primaryLabel) {
        let internalPrimaryLabel = primaryLabels.find(({name}) => name === primaryLabel);
        console.log('Primary label passed in in treeitem: '+internalPrimaryLabel?.name);
        if(internalPrimaryLabel){
          setSelectedPrimaryLabel(internalPrimaryLabel);
          return internalPrimaryLabel;
        }
        else {
          return internalPrimaryLabel = {id:1, name:primaryLabel}; //TODO: Not sure what this is.
        }
      }
    }

    const filteredPrimaryLabels =
    query === ''
      ? primaryLabels
      : primaryLabels.filter((primaryLabel) => {
          return primaryLabel.name.toLowerCase().includes(query.toLowerCase())
        })

    //TODO: Fix the possible invocation of null event handlers. Default handler(s)?

    // There are esoteric differences between onInput and onChange - even though it seems 
    // one should be able use either (interchangably?) for the same purpose(s)...
    return (
      <li 
        onMouseEnter={handleMouseEntersListItemArea}
        onMouseLeave={handleMouseLeavesListItemArea}
        onClick={handleClick}
        className={classNames(
          styles.Wrapper,
          clone && styles.clone,
          ghost && styles.ghost,
          indicator && styles.indicator,
          disableSelection && styles.disableSelection,
          disableInteraction && styles.disableInteraction,
          done && styles.TreeItemDone
        )}
        ref={wrapperRef}
        style={
          {
            '--spacing': `${indentationWidth * depth}px`,
          } as React.CSSProperties
        }
        {...props}
      >
        <div className={classNames(styles.TreeItem, highlighted && styles.TreeItemHighlighted)} ref={ref} style={style}>
          {draggable && (
            <Handle {...handleProps} />
          )}
          {onCollapse && (
            <Action
              onClick={onCollapse}
              onMouseEnter={handleMouseEntersItemNonSelectionArea} 
              onMouseLeave={handleMouseLeavesItemNonSelectionArea}
              className={classNames(
                styles.Collapse,
                collapsed && styles.collapsed
              )}
            >
              {collapseIcon}
            </Action>
          )}

          
          <span className={styles.Text}>
            <TaskTextField  title={value} onTitleChange={onTitleChanged} handleOnFocus={treeItemHandleOnfocus} index={0} inputRefs={localInputRefs} handleOnSubmit={handleOnSubmit} ref={inputRef}></TaskTextField>
          </span>

          {/* <Combobox value={selectedPrimaryLabel} onChange={handlePrimaryLabelChange} onClose={() => setQuery('')}>
            <ComboboxInput
              aria-label="Primary Label"
              displayValue={(primaryLabel) => primaryLabel?.name}
              onChange={(event) => setQuery(event.target.value)}
            />
            <ComboboxOptions anchor="bottom" className="">
              {query.length > 0 && (
                <ComboboxOption value={{ id: null, name: query }} className={styles.ListItem}>
                  Create <span className="font-bold">"{query}"</span>
                </ComboboxOption>
              )}
              {filteredPrimaryLabels.map((primaryLabel) => (
                <ComboboxOption key={primaryLabel.id} value={primaryLabel} className={styles.ListItem}>
                  {primaryLabel.name}
                </ComboboxOption>
              ))}
            </ComboboxOptions>
          </Combobox> */}

          <Action
            onClick={onGoalChanged}
            onMouseEnter={handleMouseEntersItemNonSelectionArea} 
            onMouseLeave={handleMouseLeavesItemNonSelectionArea}
            className={classNames(
              styles.NotGoal,
              goal && styles.goal
            )}
          >
            <EmojiEvents />
          </Action>
          <Listbox value={selectedStatus} onChange={onSelectedStatusChanged}>
            <ListboxButton
            onMouseEnter={handleMouseEntersItemNonSelectionArea} 
                   onMouseLeave={handleMouseLeavesItemNonSelectionArea}>
              {selectedStatus.name}
            </ListboxButton>
              <ListboxOptions anchor="bottom" 
                              className={styles.ListItem}>
                {states.map((state) => (
                  <ListboxOption key={state.id} value={state} className={styles.ListItem}>
                    {state.name}
                  </ListboxOption>
                ))}
            </ListboxOptions>
          </Listbox>
          <Listbox value={selectedPrimaryLabel} onChange={onSelectedPrimaryLabelChanged}>
            <ListboxButton 
                   onMouseEnter={handleMouseEntersItemNonSelectionArea} 
                   onMouseLeave={handleMouseLeavesItemNonSelectionArea}>{selectedPrimaryLabel.name}
            </ListboxButton>
              <ListboxOptions anchor="bottom">
                {primaryLabels.map((primaryLabel) => (
                  <ListboxOption key={primaryLabel.id} value={primaryLabel} className={styles.ListItem}>
                    {primaryLabel.name}
                  </ListboxOption>
                ))}
            </ListboxOptions>
          </Listbox>
          <label>
            <input name='doneCheckbox' className={styles.Checkbox} type='checkbox' defaultChecked={done} onInput={onDoneChanged}/>
            Done?
          </label>

          {/* <label>To do by:</label> */}

          <div className={styles.DateGroup}>
          <label>
            Estimated Commencement
            <input name='estimatedCommencementDateTime' className={styles.Checkbox} type='datetime-local' 
                   value={estimatedCommencementDate} 
                   onMouseEnter={handleMouseEntersItemNonSelectionArea} 
                   onMouseLeave={handleMouseLeavesItemNonSelectionArea}
                   onChange={(e) => onEstimatedCommencementDateChanged(e.target.value)}/>
          </label>
          <label>
            Scheduled Start/Ideal Completion
            <input name='idealCompletionDateTime' className={styles.Checkbox} type='datetime-local' 
                   value={idealCompletionDate} 
                   onMouseEnter={handleMouseEntersItemNonSelectionArea} 
                   onMouseLeave={handleMouseLeavesItemNonSelectionArea}
                   onChange={(e) => onIdealDateChanged(e.target.value)}/>
          </label>
          <label>
            Scheduled End/Latest Possible
            <input name='latestPossibleCompletionDateTime' className={styles.Checkbox} type='datetime-local' 
                   value={latestPossibleCompletionDate} 
                   onMouseEnter={handleMouseEntersItemNonSelectionArea} 
                   onMouseLeave={handleMouseLeavesItemNonSelectionArea}
                   onChange={(e) => onLatestDateChanged(e.target.value)}/>            
          </label>
          </div>

          {/* <label>
            Status
            <input type="text" name="example" list="taskStateList" 
                   value={status} onChange={(e) => onStatusChanged(e.target.value)}
                   placeholder={"New"}/>
            <datalist id="taskStateList">
              <option>New</option>
              <option value="Processing"/>
              <option value="Ready">Ready</option>
              <option value="Scheduled">Scheduled</option>
            </datalist>
          </label> */}

          {!clone && onRemove && <Remove onClick={onRemove}/>}
          {/* <IsolateItem onClick={onNavTo}/> */}
          {clone && childCount && childCount > 1 ? (
            <span className={styles.Count}>{childCount}</span>
          ) : null}
        </div>
      </li>
    );
  }
);

const collapseIcon = (
  <svg width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 41">
    <path d="M30.76 39.2402C31.885 40.3638 33.41 40.995 35 40.995C36.59 40.995 38.115 40.3638 39.24 39.2402L68.24 10.2402C69.2998 9.10284 69.8768 7.59846 69.8494 6.04406C69.822 4.48965 69.1923 3.00657 68.093 1.90726C66.9937 0.807959 65.5106 0.178263 63.9562 0.150837C62.4018 0.123411 60.8974 0.700397 59.76 1.76024L35 26.5102L10.24 1.76024C9.10259 0.700397 7.59822 0.123411 6.04381 0.150837C4.4894 0.178263 3.00632 0.807959 1.90702 1.90726C0.807714 3.00657 0.178019 4.48965 0.150593 6.04406C0.123167 7.59846 0.700153 9.10284 1.75999 10.2402L30.76 39.2402Z" />
  </svg>
);
